import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'data-table',
    templateUrl: './data.table.component.html',
    styleUrls: [ './data.table.component.scss' ]
})
export class DataTableComponent {
    public _isLoading = true;

    get isLoading() {
        return this._isLoading;
    }

    @Input() set isLoading(isLoading) {
        this._isLoading = isLoading;
    }

    @Input() public rows:Array<any> = [];
    @Input() public config:any = {};

    // Outputs (Events)
    @Output() public tableChanged:EventEmitter<any> = new EventEmitter();

    /**
     ** Pager
     **/
    private _pager: any;

    public changePage(p) {
        this.tableChanged.emit({page: p});
        this._pager.page = p;
    }

    public get pages():Array<any> {
        let ret = [];
        for (let i = 1; i <= this.getLastPage(); i++) {
            ret.push(i);
        }
        return ret;
    }

    public getActivePage() {
        return this._pager.page;
    }

    public isFirstPage() {
        return this._pager.page == 1;
    }

    public isLastPage() {
        return this.getLastPage() == this._pager.page;
    }

    public getLastPage() {
        return Math.ceil(this._pager.total / this._pager.perPage)
    }

    @Input()
    public set pager(pager: any) {
        this._pager = pager;
    }


    public get pager() {
        return this._pager;
    }
    /**
     ** Columns
     **/
    private _columns:Array<any> = [];

    public get columns():any {
        return this._columns;
    }

    @Input()
    public set columns(values:any) {

        values.forEach((value:any) => {
            let column = this._columns.find((col:any) => col.name === value.name);
            if (column) {
                Object.assign(column, value);
            }
            if (!column) {
                this._columns.push(value);
            }
        });
    }

    /**
     ** Buttons
     **/
    @Input() public _buttons:Array<any> = [];

    public get buttons():Array<any> {
        return this._buttons;
    }


    @Input()
    public set buttons(buttons:Array<any>) {
        this._buttons = buttons;
    }

    /**
     ** Data
     **/
    public getData(row:any, propertyName:string):string {
        return propertyName.split('.').reduce((prev:any, curr:string) => prev[curr], row);
    }

    public getBoolean(row:any, propertyName:string):string {
        return this.getData(row, propertyName) ? 'fa fa-check' : 'fa fa-remove';
    }

}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/data-table/data.table.component.ts